import { Component, OnInit } from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'kt-signal-unstable',
  templateUrl: './signal-unstable.component.html',
  styleUrls: ['./signal-unstable.component.scss']
})
export class SignalUnstableComponent implements OnInit {

  constructor(
    private translate: TranslateService,
    public dialogRef: MatDialogRef<SignalUnstableComponent>
  ) { }

  ngOnInit(): void {
  }

  getCurrentLanguage() {
    return localStorage.getItem('language') || this.translate.getDefaultLang();
  }
  openVideo() {
    if (this.getCurrentLanguage() === 'de') {
      window.open('https://www.youtube.com/watch?v=6JAnQyOBF3E', '_blank')
    } else {
      window.open('https://www.youtube.com/watch?v=_N13ZY7EG1k', '_blank')
    }
  }
  close() {
    this.dialogRef.close();
  }
}
